if (!customElements.get('supplement-facts-modal')) {
  customElements.define(
    'supplement-facts-modal',
    class SupplementFactsModal extends ModalDialog {
      constructor() {
        super();
      }

      // ModalOpener calls modal.showActiveMedia(contentID) before show().
      // This modal has a single content body (not per-id like certifications),
      // so this is a no-op — defined to keep the call-site contract.
      showActiveMedia() {}

      show(opener) {
        super.show(opener);
        // AC: focus moves to the close button on open (super focuses the dialog wrapper).
        const closeBtn = this.querySelector('[id^="ModalClose-"]');
        if (closeBtn) closeBtn.focus();
      }

      hide() {
        super.hide();
      }
    }
  );
}
